import React, { useEffect, useState } from "react";
import axios from "axios";

const ImageProfil = ({ id, style, className }) => {
  const [imageUrl, setImageUrl] = useState(null);

  useEffect(() => {
    if (id) {
      axios
        .get(`${process.env.REACT_APP_API_URL}/api/user/avatar/${id}`)
        .then((response) => setImageUrl(response.data))
        .catch(() => setImageUrl(null));
    }
  }, [id]);

  if (!imageUrl) return null;

  return <img src={imageUrl} alt="Avatar" style={style || {}} className={className || ""} />;
};

export default ImageProfil;
